import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class ReportMailConfigService {
    private headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });
    private baseUrl = 'api/reportMailConfig';

    constructor(private http: Http) { }

    private extractData(res: any) {
        return res.json() || [];
    }

    getList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }
        return this.http.get(`${this.baseUrl}/list`, new RequestOptions({ headers: this.headers, search: params }))
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getMailsByReport(report_name: string): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('report_name', report_name);
        return this.http.get(`${this.baseUrl}/mailsByReport`, new RequestOptions({ headers: this.headers, search: params }))
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getReportNames(): Promise<any> {
        return this.http.get(`${this.baseUrl}/reportNames`, new RequestOptions({ headers: this.headers }))
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getActiveEmployeeEmails(): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('start', '0');
        params.set('limit', '9999');
        params.set('orderColumn', 'employee_name');
        params.set('orderDir', 'asc');
        return this.http.get('api/employeeEmailConfig/list', new RequestOptions({ headers: this.headers, search: params }))
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    uploadExcel(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/uploadExcel`, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    addUpdate(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/addUpdate`, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    delete(mail_config_id: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/delete`, $.param({ mail_config_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('ReportMailConfigService error', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/reportMailConfig.service.ts